// third-party
import { createSlice } from '@reduxjs/toolkit';
import { dispatch } from '../index';
import {API} from "aws-amplify";

const apiName = process.env.REACT_APP_ENDPOINT_NAME;
const path_post_remove_connection = process.env.REACT_APP_AUTH_POST_REMOVE_CONNECTIONS
const path_get_connections = process.env.REACT_APP_AUTH_GET_CONNECTIONS;
const path_get_subscriptions = process.env.REACT_APP_AUTH_GET_SUBSCRIPTIONS_LIST;
const path_get_users_list = process.env.REACT_APP_AUTH_GET_USERS_LIST;
const path_post_add_user = process.env.REACT_APP_AUTH_POST_ADD_USER;
const path_post_remove_user = process.env.REACT_APP_AUTH_POST_REMOVE_USER;
const path_post_confirm_signup = process.env.REACT_APP_AUTH_POST_CONFIRM_SIGNUP;


const initialState = {
    error_xero_connection: null,
    xero_tenant: {},
    selected_tenant: null,
    connections_list: [],
    subscription_list: [],
    selected_subscription: null,
    users_list: [],
    removeUserPopup: false,
    confirmSignupPopup: false
}

const xeroconnection = createSlice({
    name: "xeroconnection",
    initialState,
    reducers: {
        hasError(state, action) {
            console.log(action);
          state.error_xero_connection = action.payload.response;
          // state.connections_list = [];
        },
        handlerSetXeroTenant(state, action){
          state.xero_tenant=action.payload.xero_tenant;
          return state
        },
        handlerSetXeroConnectionsList(state, action){
            state.connections_list = action.payload.connections_list;
            return state;
        },
        handlerSetSubscriptionSelect(state, action){
            console.log(action);
          state.selected_subscription=action.payload.selected_subscription;
          return state
        },
        getConnectionsSuccess(state, action){
          state.connections_list = action.payload.connections_list;
          state.error_xero_connection = null;
          return state;
        },
        removeConnectionSuccess(state, action){
            state.connections_list = action.payload.connections_list;
            state.error_xero_connection = null;
            return state;
        },
        getSubscriptionsSuccess(state, action){
            console.log(action.payload.data.subscription_list)
            state.subscription_list = action.payload.data.subscription_list;
            state.error_xero_connection = null;
            return state;
        },
        getUsersListSuccess(state, action){
            console.log(action)
            state.users_list = action.payload.data.users_list;
            state.error_xero_connection = null;
        },
        postAddUserSuccess(state, action) {
            state.users_list = action.payload.data.users_list;
            state.selected_subscription = action.payload.data.selected_subscription;
            state.error_xero_connection = null;
        },
        postRemoveUserSuccess(state, action) {
            state.users_list = action.payload.data.users_list;
            state.selected_subscription = action.payload.data.selected_subscription;
            state.error_xero_connection = null;
        },
        postConfirmSignupSuccess(state, action) {
            state.users_list = action.payload.data.users_list;
            state.selected_subscription = action.payload.data.selected_subscription;
            state.error_xero_connection = null;
        },
        removeUserPopupToggle(state, action) {
            state.removeUserPopup = action.payload.removeUserPopup;
            state.error_xero_connection = null;
        },
        confirmSignupPopupToggle(state, action){
            state.confirmSignupPopup = action.payload.confirmSignupPopup;
            state.error_xero_connection = null;
        }
    }
});

export default xeroconnection.reducer;

export function getConnections(xero_tenant) {
    return async () => {
    var myInit = {};
    myInit = {
      headers: {},
      response: true,
      queryStringParameters: {
        "xero_tenant": xero_tenant
      }
    }
    API.get(apiName,path_get_connections,myInit)
        .then(response => {
          console.log(response);
          dispatch(xeroconnection.actions.getConnectionsSuccess(response.data))
        }).catch(error => {
          dispatch(xeroconnection.actions.hasError(error))
    })
  };
}

export function getSubscriptions(user_email) {
    return async () => {
    var myInit = {};
    myInit = {
      headers: {},
      response: true,
      queryStringParameters: {
        "user_email": user_email
      }
    }
    API.get(apiName,path_get_subscriptions,myInit)
        .then(response => {
          console.log(response);
          dispatch(xeroconnection.actions.getSubscriptionsSuccess(response.data))
        }).catch(error => {
          dispatch(xeroconnection.actions.hasError(error))
    })
  };
}

export function getUsersList(user_email, selected_subscription) {
    return async () => {
    var myInit = {};
    myInit = {
      headers: {},
      response: true,
      queryStringParameters: {
          "user_email": user_email,
        "selected_subscription": JSON.stringify(selected_subscription)
      }
    }
    API.get(apiName,path_get_users_list,myInit)
        .then(response => {
          dispatch(xeroconnection.actions.getUsersListSuccess(response.data))
        }).catch(error => {
          dispatch(xeroconnection.actions.hasError(error))
    })
  };
}

export function postRemoveConnection(xero_tenant, connection_id, selected_subscription_id){
    return async() => {
    var myInit = {};
    myInit = {
      headers: {},
      body: {xero_tenant, connection_id, selected_subscription_id}
    }
    API.post(apiName, path_post_remove_connection, myInit)
        .then(response => {
            dispatch(xeroconnection.actions.removeConnectionSuccess(response.data))
        }).catch(error => {
            dispatch(xeroconnection.actions.hasError(error))
    })
  };
}

export function postAddUser(user_email, user_role, selected_subscription){
    console.log("adding user");
    return async() => {
    var myInit = {};
    myInit = {
      headers: {},
      body: {
        user_email, user_role, selected_subscription
      }
    }
    console.log(myInit);
    API.post(apiName, path_post_add_user, myInit)
        .then(response => {
            dispatch(xeroconnection.actions.postAddUserSuccess(response.data))
        }).catch(error => {
            dispatch(xeroconnection.actions.hasError(error))
    })
  };
}

export function postRemoveUser(user_email, selected_subscription){
    return async() => {
    var myInit = {};
    myInit = {
      headers: {},
      body: {
        user_email, selected_subscription
      }
    }
    API.post(apiName, path_post_remove_user, myInit)
        .then(response => {
            dispatch(xeroconnection.actions.postRemoveUserSuccess(response.data))
        }).catch(error => {
            dispatch(xeroconnection.actions.hasError(error))
    })
  };
}

export function postConfirmSignup(user_email, selected_subscription){
    return async() => {
    var myInit = {};
    myInit = {
      headers: {},
      body: {
        user_email, selected_subscription
      }
    }
    API.post(apiName, path_post_confirm_signup, myInit)
        .then(response => {
            dispatch(xeroconnection.actions.postCreateUserSuccess(response.data))
        }).catch(error => {
            dispatch(xeroconnection.actions.hasError(error))
    })
  };
}

//
export const {handlerSetXeroTenant, handlerSetSubscriptionSelect, handlerSetXeroConnectionsList, removeUserPopupToggle, confirmSignupPopupToggle} = xeroconnection.actions;